/**
 * @generated SignedSource<<4392b0f67eb124d85541f7a52c8a6c2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type OrganizationMembershipsProfileFieldStatus = "not_responded" | "responded" | "%future added value";
export type ProductRole = "instructor" | "manager" | "member" | "%future added value";
export type MemberGroupFilterInput = {
  memberGroupId?: string | null;
  unassigned?: boolean | null;
};
export type OrganizationMembershipsProfileFieldFilter = {
  id: string;
  optionId?: string | null;
  status?: OrganizationMembershipsProfileFieldStatus | null;
};
export type OrderByInput = {
  direction: OrderDirection;
  field: string;
};
export type ProductMembersListQuery$variables = {
  after?: string | null;
  canMakeTeacher: boolean;
  canUnenroll: boolean;
  first: number;
  groupIds?: ReadonlyArray<string> | null;
  id: string;
  memberGroupFilterInput?: MemberGroupFilterInput | null;
  orderBy?: OrderByInput | null;
  productRoles?: ReadonlyArray<ProductRole> | null;
  profileFields?: ReadonlyArray<OrganizationMembershipsProfileFieldFilter> | null;
  search?: string | null;
};
export type ProductMembersListQuery$data = {
  readonly node: {
    readonly id?: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProductMembersList_PaginationFragment">;
  } | null;
};
export type ProductMembersListQuery = {
  response: ProductMembersListQuery$data;
  variables: ProductMembersListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canMakeTeacher"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canUnenroll"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupIds"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberGroupFilterInput"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productRoles"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "profileFields"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v11 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v14 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v15 = {
  "kind": "Variable",
  "name": "groupIds",
  "variableName": "groupIds"
},
v16 = {
  "kind": "Variable",
  "name": "memberGroupFilterInput",
  "variableName": "memberGroupFilterInput"
},
v17 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v18 = {
  "kind": "Variable",
  "name": "profileFields",
  "variableName": "profileFields"
},
v19 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v21 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  {
    "kind": "Variable",
    "name": "roles",
    "variableName": "productRoles"
  },
  (v19/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v23 = [
  {
    "kind": "Literal",
    "name": "groupKinds",
    "value": [
      "custom"
    ]
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductMembersListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v12/*: any*/),
              {
                "args": [
                  (v13/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "canMakeTeacher",
                    "variableName": "canMakeTeacher"
                  },
                  {
                    "kind": "Variable",
                    "name": "canUnenroll",
                    "variableName": "canUnenroll"
                  },
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "productRoles",
                    "variableName": "productRoles"
                  },
                  (v18/*: any*/),
                  (v19/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "ProductMembersList_PaginationFragment"
              }
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProductMembersListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          (v12/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v21/*: any*/),
                "concreteType": "ProductMembershipNodeConnection",
                "kind": "LinkedField",
                "name": "productMemberships",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductMembershipNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductMembership",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "member",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "avatar",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bio",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fullName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isTest",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": (v23/*: any*/),
                            "concreteType": "MemberGroupMembershipNodeConnection",
                            "kind": "LinkedField",
                            "name": "memberGroupMemberships",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberGroupMembershipNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MemberGroupMembership",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v24/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MemberGroup",
                                        "kind": "LinkedField",
                                        "name": "memberGroup",
                                        "plural": false,
                                        "selections": [
                                          (v12/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "parentMemberGroupId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "visibility",
                                            "storageKey": null
                                          },
                                          (v25/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "kind",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "color",
                                            "storageKey": null
                                          },
                                          (v22/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isSystem",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "kind": "LinkedField",
                                            "name": "product",
                                            "plural": false,
                                            "selections": [
                                              (v12/*: any*/),
                                              (v25/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v20/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v26/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfoObjectType",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v28/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "memberGroupMemberships(groupKinds:[\"custom\"])"
                          },
                          {
                            "alias": null,
                            "args": (v23/*: any*/),
                            "filters": [
                              "groupKinds"
                            ],
                            "handle": "connection",
                            "key": "useMemberGroupTagsList_ProductMembershipFragment_memberGroupMemberships",
                            "kind": "LinkedHandle",
                            "name": "memberGroupMemberships"
                          },
                          (v20/*: any*/),
                          {
                            "condition": "canMakeTeacher",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "email",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v25/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "type",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "condition": "canUnenroll",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "memberId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Organization",
                                    "kind": "LinkedField",
                                    "name": "organization",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "stripeDashboardURL",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfoObjectType",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      },
                      (v27/*: any*/),
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v21/*: any*/),
                "filters": [
                  "roles",
                  "memberGroupFilterInput",
                  "profileFields",
                  "groupIds",
                  "search",
                  "orderBy"
                ],
                "handle": "connection",
                "key": "ProductMembersList__productMemberships",
                "kind": "LinkedHandle",
                "name": "productMemberships"
              }
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6f77dfe5bc3bc161a1ff654d3dcd83de",
    "id": null,
    "metadata": {},
    "name": "ProductMembersListQuery",
    "operationKind": "query",
    "text": "query ProductMembersListQuery(\n  $id: ID!\n  $canMakeTeacher: Boolean!\n  $canUnenroll: Boolean!\n  $productRoles: [ProductRole!]\n  $memberGroupFilterInput: MemberGroupFilterInput\n  $groupIds: [ID!]\n  $profileFields: [OrganizationMembershipsProfileFieldFilter!]\n  $search: String\n  $orderBy: OrderByInput\n  $first: Int!\n  $after: String\n) {\n  node(id: $id) {\n    __typename\n    ... on Product {\n      id\n      ...ProductMembersList_PaginationFragment_IGFjY\n    }\n    id\n  }\n}\n\nfragment MakeProductTeacherButtonFragment on ProductMembership {\n  id\n  email\n  member {\n    fullName\n    id\n  }\n  product {\n    id\n    name\n    type\n  }\n}\n\nfragment MemberGroupTagFragment on MemberGroup {\n  id\n  name\n  kind\n  color\n  role\n  isSystem\n  product {\n    id\n    name\n  }\n}\n\nfragment ProductMemberCardFragment_1UH7SA on ProductMembership {\n  id\n  role\n  ...MakeProductTeacherButtonFragment @include(if: $canMakeTeacher)\n  ...UnenrollProductMemberButtonFragment @include(if: $canUnenroll)\n  ...useMemberGroupTagsList_ProductMembershipFragment\n  member {\n    id\n    avatar\n    firstName\n    lastName\n    ...UserCardFragment\n  }\n}\n\nfragment ProductMembersList_PaginationFragment_IGFjY on Product {\n  productMemberships(roles: $productRoles, memberGroupFilterInput: $memberGroupFilterInput, profileFields: $profileFields, groupIds: $groupIds, search: $search, orderBy: $orderBy, first: $first, after: $after) {\n    totalCount\n    edges {\n      node {\n        id\n        member {\n          id\n          firstName\n        }\n        ...ProductMemberCardFragment_1UH7SA\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      startCursor\n      endCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n  id\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment UnenrollProductMemberButtonFragment on ProductMembership {\n  id\n  productId\n  role\n  memberId\n  member {\n    fullName\n    id\n  }\n  product {\n    organization {\n      id\n      stripeDashboardURL\n    }\n    id\n  }\n}\n\nfragment UserCardFragment on User {\n  id\n  bio\n  fullName\n  ...ProfileAvatarFragment\n}\n\nfragment useMemberGroupTagsList_ProductMembershipFragment on ProductMembership {\n  id\n  memberGroupMemberships(groupKinds: [custom]) {\n    edges {\n      node {\n        id\n        productId\n        memberGroup {\n          id\n          parentMemberGroupId\n          visibility\n          ...MemberGroupTagFragment\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d713ef6ca68f6ae586a1c21bc4b353d7";

export default node;
